import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './LightSwitch.module.scss';

export const LightSwitch = ({
    children, className,
    checked, onChange
}: Props) => (

    <div className={classNames(styles.container, className)}
        onClick={() => onChange(!checked)}>

        <div className={classNames(styles.default, { [styles.checked]: checked })}>
            <div className={styles.backdrop} />
            <div className={styles.inner} />
        </div>

        <p className={styles.label}>
            {children}
        </p>
    </div>
);

type Props = PropsWithChildren<{
    className?: string;
    checked: boolean;
    onChange: (value: boolean) => void;
}>;